module.exports = __webpack_public_path__ + "img/dron_felvetelek_pop_up.6e0dd8a8.png";